import { render, staticRenderFns } from "./SearchStatementSimples.vue?vue&type=template&id=71838652&"
import script from "./SearchStatementSimples.vue?vue&type=script&lang=js&"
export * from "./SearchStatementSimples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports